import { h, Host } from "@stencil/core";
export class ModalContent {
    render() {
        return (h(Host, { key: '47b8469fea541427c366bfa78e16f41744fe2b43', class: "ux-modal-content" }, h("slot", { key: 'cfb0dbd2863266f756ad6119dcc545ccc1ea804d' })));
    }
    static get is() { return "ux-modal-content"; }
    static get originalStyleUrls() {
        return {
            "$": ["modal-content.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["modal-content.css"]
        };
    }
}
//# sourceMappingURL=modal-content.js.map
